import React from 'react'
import { Button, Empty, Tag, Typography } from 'antd'
import { EditOutlined } from '@ant-design/icons'
import { FollowUp, FOLLOW_UP_TYPE_LABELS, LEAD_STATUS_LABELS, LeadStatus, fmtTime } from '../lib/api'

const { Text } = Typography

interface Props {
  items: FollowUp[]
  onEdit?: (followup: FollowUp) => void
}

/** 线索全生命周期时间轴（follow_ups 倒序渲染；note/status_change/tour/system） */
const FollowTimeline: React.FC<Props> = ({ items, onEdit }) => {
  if (!items || items.length === 0) {
    return <Empty description="暂无跟进记录" image={Empty.PRESENTED_IMAGE_SIMPLE} />
  }
  return (
    <div>
      {items.map((it) => {
        const t = FOLLOW_UP_TYPE_LABELS[it.type] ?? { label: it.type, color: '#7F8C8D' }
        const statusText =
          it.type === 'status_change' && it.newStatus
            ? `${LEAD_STATUS_LABELS[it.prevStatus as LeadStatus]?.label ?? it.prevStatus ?? '—'} → ${
                LEAD_STATUS_LABELS[it.newStatus as LeadStatus]?.label ?? it.newStatus
              }`
            : null
        return (
          <div key={it.id} style={{ display: 'flex', gap: 10, padding: '10px 0', borderBottom: '1px dashed #EEF1F4' }}>
            <span
              style={{ width: 9, height: 9, borderRadius: '50%', flexShrink: 0, marginTop: 5, background: t.color }}
            />
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
                <Tag color={t.color} style={{ marginInlineEnd: 0 }}>{t.label}</Tag>
                {statusText && <Text strong style={{ fontSize: 13 }}>{statusText}</Text>}
                <Text type="secondary" style={{ fontSize: 12 }}>
                  {fmtTime(it.createdAt)}{it.operatorName ? ` · ${it.operatorName}` : ''}
                </Text>
              </div>
              {it.content && <div style={{ marginTop: 4, fontSize: 13 }}>{it.content}</div>}
              {it.type === 'tour' && (
                <div style={{ marginTop: 4, fontSize: 13, color: '#34495E' }}>
                  带看时间：{fmtTime(it.tourAt)}
                  {it.tourUnit ? ` · 单元：${it.tourUnit}` : ''}
                  {it.tourFeedback ? ` · 反馈：${it.tourFeedback}` : ''}
                </div>
              )}
              {it.nextContactAt && (
                <div style={{ marginTop: 4, fontSize: 12, color: '#F39C12' }}>
                  下次联系：{fmtTime(it.nextContactAt)}
                </div>
              )}
            </div>
            {onEdit && (it.type === "note" || it.type === "tour") && (
              <Button
                size="small"
                icon={<EditOutlined />}
                onClick={() => onEdit(it)}
                style={{ flexShrink: 0, alignSelf: "flex-start" }}
              >
                编辑
              </Button>
            )}
          </div>
        )
      })}
    </div>
  )
}

export default FollowTimeline
